export default __webpack_public_path__ + "static/19-1fefc34bf6ffc73b15edf41e07ca1f9d.jpg";